import type { TFunction } from "i18next";
import U2000DeleteRecordDialog from "../../../../../u2000Core/components/dialog/U2000DeleteRecordDialog";
import type { U2103LogicalUnit } from "../../../../U2103Service";
import type { U2103UserActionHandler } from "./U2103UserActionHandlers";

// Typage des props du composant
interface U2103UserActionDeleteDlgProps {
  u2103UserActionHandler: U2103UserActionHandler;
  t: TFunction;
  NS: string;
}

function U2103UserActionDeleteDlg({ u2103UserActionHandler, t, NS }: U2103UserActionDeleteDlgProps) {
  // Plus besoin de helpers custom, U2000CheckBoxArray gère tout

  if (!u2103UserActionHandler.isDeleteDialogOpen) return null;

  return (
    <U2000DeleteRecordDialog isOpen={u2103UserActionHandler.isDeleteDialogOpen} onClose={u2103UserActionHandler.onDlgDeleteClose} title={t("lblLogicalUnitAction", { ns: NS })}>
      <p className="mb-4">
        {t("msgDeleteLogicalUnitAction", {
          count: u2103UserActionHandler.gridStateHandlers.getSelectedRows().length,
          ns: NS,
        })}
      </p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {u2103UserActionHandler.gridStateHandlers.getSelectedRows().map((row, index, array) => {
          const lu = row as unknown as U2103LogicalUnit;
          return (
            <span key={lu.logicalUnitCode} className="inline-block text-gray-800">
              {`${lu.logicalUnitCode} - ${lu.logicalUnitDescription}`}
              {index < array.length - 1 && ", "}
            </span>
          );
        })}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U2103UserActionDeleteDlg;
